var path = './tasks/empty_task_list/empty_task_list.html';
var html = "<div class=\"centered\">\n    <div class=\"empty-task-list-background\"></div>\n    <span id=\"emptyMessage\" class=\"wd-text-l18 empty-message\">{{getEmptyMessage()}}</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;